import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/what-is-treatment-resistant-depression")(
  {
    beforeLoad: () => {
      throw redirect({
        to: "/learn/$slug",
        params: { slug: "what-is-treatment-resistant-depression" },
      });
    },
  },
);
